import { useState, useEffect } from "react";
import styles from "../ImportSheet/ImportSheetModal.module.css";
import CloseModalIcon from "../../../assets/closeModalIcon.svg";
import { getStoresFromDatabase } from "../../../hooks/Store";
import { getTemplatesFromDatabase } from "../../../hooks/Template";
import { importProductsFromDatabase } from "../../../hooks/Product";
import * as XLSX from "xlsx";

function Modal({ closeModal }) {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [fileName, setFileName] = useState("");
  const [selectedStores, setSelectedStores] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [stores, setStores] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const fetchStores = async () => {
      const storeData = await getStoresFromDatabase();
      if (storeData) {
        setStores(storeData.data.stores);
      }
    };
    fetchStores();
  },[]);

  useEffect(() => {
    const fetchTemplates = async () => {
      const templateData = await getTemplatesFromDatabase();
      if (templateData) {
        setTemplates(templateData.data.templates);
      }
    };
    fetchTemplates();
  },[]);


  const importProductSheet = async ( importData ) => {
      setIsProcessing(true);
      const result = await importProductsFromDatabase(importData)
      if (result) {
        setIsProcessing(false);
        alert(`${result.data.createdCount} Produtos importados com sucesso!`)
        closeModal()
      } else {
        setIsProcessing(false);
        alert("Erro ao importar produtos, verifique sua planilha!")
        console.log(`Erro ao importar produtos:`);
      }
  }

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStores([]);
    } else {
      setSelectedStores(stores);
    }
    setSelectAll(!selectAll);
  };

  const handleStoreSelection = (store) => {
    if (selectedStores.includes(store)) {
      setSelectedStores(selectedStores.filter((s) => s !== store));
    } else {
      setSelectedStores([...selectedStores, store]);
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };

  const importSheet = async () => {
  if (!fileName || !selectedTemplate || selectedStores.length === 0) {
    alert("Certifique-se de selecionar um arquivo, template e pelo menos uma loja.");
    return;
  }
  try {
    const fileInput = document.getElementById("fileUpload").files[0];
    if (!fileInput) {
      alert("Por favor, selecione um arquivo antes de importar.");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      const template = templates.find((t) => t.id === parseInt(selectedTemplate));
      if (!template) {
        alert("Template não encontrado.");
        return;
      }

      const startRow = template.line || 1;
      const columnMap = {
        barcode: template.barcode,
        name: template.productName,
        manufacturer: template.manufacturer,
        group: template.group,
      };
      const products = rows.slice(startRow - 1).reduce((acc, row) => {
        if (!row || row.every((cell) => cell === undefined || cell === null || cell === "")) {
          return acc;
        }
        const product = {
          barcode: row[columnMap.barcode.charCodeAt(0) - 65],
          name: row[columnMap.name?.charCodeAt(0) - 65],
          manufacturer: row[columnMap.manufacturer?.charCodeAt(0) - 65],
          group: row[columnMap.group?.charCodeAt(0) - 65],
        };

        const barcode = String(product.barcode ?? "").trim();

        if (barcode === "" || barcode.length > 14) {
          return acc;
        }

      product.barcode = barcode;
      acc.push(product);
      return acc;
      }, []);
      const importData = {
        storeIds: selectedStores.map((s) => s.id),
        products: products,
      };
      if (products.length === 0) {
        alert("Nenhum produto válido encontrado para importar.");
        return;
      }
      importProductSheet(importData);
    };
    reader.readAsArrayBuffer(fileInput);
  } catch (error) {
    console.error("Erro ao processar a planilha:", error);
    alert("Erro ao processar a planilha.");
  }
};
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
      { isProcessing && (
                <div className={styles.spinnerContainer}>
                  <div className={styles.spinner}></div>
                </div>
              )}
        <div className={styles.content}>
          <div className={styles.imageContainer}>
            <img src={CloseModalIcon} onClick={closeModal} alt="Fechar Modal" />
          </div>
          <h2>Planilha de produtos</h2>
          <div className={styles.inputContainer}>
            <label>Selecione as lojas:</label>
            <div
              className={styles.selectWrapper}
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <div className={styles.dropdownHeader}>
                <span id={styles.selectStores}>
                {selectedStores.length > 0
                  ? `${selectedStores.length} loja(s) selecionada(s)`
                  : "Selecionar lojas"}
                </span>
                <span className={styles.dropdownArrow}>▼</span>
              </div>
              {dropdownOpen && (
                <div className={styles.dropdownList}>
                  <div className={styles.checkboxItem}>
                    <input
                      type="checkbox"
                      id="selectAll"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    <label htmlFor="selectAll">Selecionar todas</label>
                  </div>
                  { stores.map((store) => (
                    <div className={styles.checkboxItem} key={store.id}>
                      <input
                        type="checkbox"
                        id={store.id}
                        checked={selectedStores.includes(store)}
                        onChange={() => handleStoreSelection(store)}
                      />
                      <label htmlFor={store.name}>{store.name}</label>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <div className={styles.inputContainer}>
            <label htmlFor="templateInput">Escolha um template:</label>
            <div className={styles.selectWrapper}>
              <select
                id="templateInput"
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              >
                <option value="">Selecione um template</option>
                {templates.map((template) => (
                  <option key={template.id} value={template.id}>
                    {template.templateName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <label htmlFor="fileInput">Selecione um arquivo:</label>
            <input
              type="text"
              value={fileName}
              placeholder="Nenhum arquivo selecionado"
              readOnly
            />
            <button
              onClick={() => document.getElementById("fileUpload").click()}
            >
              Selecionar arquivo
            </button>
            <input
              type="file"
              id="fileUpload"
              style={{ display: "none" }}
              onChange={ handleFileSelect }
              accept=".xls,.xlsx"
            />
          </div>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ importSheet }>
            Importar Planilha
          </button>
          <button onClick={closeModal} className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
